import request from '@/utils/request'

// ------------------通用接口------------------

// 根据用户id获取账号等级(云平台-账号管理)
export function getLevelByUserId(data) {
  return request({
    url: '/user/edu/cloud/get/level/by/userId',
    method: 'post',
    data: data
  })
}

// 文件下载(post 解决特殊符号问题)
export function postDownload(data) {
  return request({
    url: '/basic/upload/post/download',
    method: 'post',
    data: data,
    responseType: 'blob',
  })
}


/** 名师教研 **/

// ------------------前台接口-数据统计------------------

// 获取活动数量
export function selectActiveCount() {
  return request({
    url: `/basic/eduCloudJyClassroom/hero/selectActiveCount`,
    method: 'get',
  })
}


// ------------------前台接口-专递课堂------------------

// 获取活动数量
export function getStatisticalData(assoGroupId) {
  return request({
    url: `/basic/deliverClass/hero/getStatisticalData?assoGroupId=${assoGroupId}`,
    method: 'get',
  })
}

// 获取微课列表接口 (池州私有化)
export function ChiZhouListByCondition(data) {
  return request({
    url: '/basic/eduCloudStudyCourse/hero/chizhou/selectListByCondition',
    method: 'post',
    data: data
  })
}

// 获取教研室列表接口 (池州私有化)
export function ChiZhouSelectHomeList(data) {
  return request({
    url: '/basic/eduCloudJyClassroom/hero/selectHomeList',
    method: 'post',
    data: data
  })
}

// 获取教学研讨列表接口 (池州私有化)
export function ChiZhouSelecteduCloudJyDiscussList(data) {
  return request({
    url: '/basic/eduCloudJyDiscuss/hero/selectHomeList',
    method: 'post',
    data: data
  })
}

// 协同备课(池州私有化)
export function ChiZhouSelecteduCloudJyPrepareLessonsList(data) {
  return request({
    url: '/basic/eduCloudJyPrepareLessons/hero/selectHomeList',
    method: 'post',
    data: data
  })
}

// 获取未登录区域结对组数据(教育云平台)
export function getNotLoggedAreaAssoGroup(data) {
  return request({
    url: '/basic/deliverClass/hero/getNotLoggedAreaAssoGroup',
    method: 'post',
    data: data
  })
}

// 获取已登录区域结对组数据(教育云平台)
export function getLoggedAreaAssoGroupData(data) {
  return request({
    url: '/basic/deliverClass/getLoggedAreaAssoGroupData',
    method: 'post',
    data: data
  })
}

// 判断当前登录人是否有权查看结对组详情 0无权限 1超管 2校管 3老师
export function isNotHaveAuthority(assoGroupId) {
  return request({
    url: `/basic/deliverClass/isNotHaveAuthority?assoGroupId=${assoGroupId}`,
    method: 'get',
  })
}

// 获取未登录专递直播数据(教育云平台)
export function getNotLoggedLiveData(data) {
  return request({
    url: '/basic/deliverClass/hero/getNotLoggedLiveData',
    method: 'post',
    data: data
  })
}

// 获取已登录专递直播数据(教育云平台)
export function getLoggedDeliverLiveData(data) {
  return request({
    url: '/basic/deliverClass/getLoggedDeliverLiveData',
    method: 'post',
    data: data
  })
}

// 校验直播课程密码(教育云平台)
export function verifyLivePassword(deliverId, livePassword) {
  return request({
    url: `/basic/deliverClass/verifyLivePassword?deliverId=${deliverId}&livePassword=${livePassword}`,
    method: 'post'
  })
}

// 获取直播课程详情(教育云平台)
export function getLiveCourseDetail(deliverId) {
  return request({
    url: `/basic/deliverClass/hero/getLiveCourseDetail?deliverId=${deliverId}`,
    method: 'post'
  })
}

// 获取总排行榜数据(教育云平台)
export function getLeaderboardData(assoGroupId) {
  return request({
    url: `/basic/deliverClass/hero/getLeaderboardData?assoGroupId=${assoGroupId}`,
    method: 'get',
  })
}

// 获取专递详情排行榜数据(教育云平台)
export function getDetailLeaderboard(assoGroupId) {
  return request({
    url: `/basic/deliverClass/getDetailLeaderboard?assoGroupId=${assoGroupId}`,
    method: 'get',
  })
}

// 获取成员校数据(教育云平台)
export function getMemberSchoolData(assoGroupId, data) {
  return request({
    url: `/basic/deliverClass/getMemberSchoolData?assoGroupId=${assoGroupId}`,
    method: 'post',
    data: data
  })
}

// 结对组详情-专递课表(教育云平台)
export function getDetailCurriculum(assoGroupId) {
  return request({
    url: `/basic/deliverClass/getDetailCurriculum?assoGroupId=${assoGroupId}`,
    method: 'post'
  })
}


// ------------------前台接口-教研室------------------

// 前端教研室列表 未登录状态(只显示全国可见)
export function researchGetList(data) {
  return request({
    url: '/basic/eduCloudJyClassroom/hero/getList',
    method: 'post',
    data: data
  })
}

// 前端教研室列表 登录状态(全国+本校+区域)
export function selectListByConditionLogin(data) {
  return request({
    url: '/basic/eduCloudJyClassroom/selectListByConditionLogin',
    method: 'post',
    data: data
  })
}

// 申请加入教研室
export function applyToJoin(eduCloudJyClassroomId) {
  return request({
    url: `/basic/eduCloudJyClassroom/applyToJoin?eduCloudJyClassroomId=${eduCloudJyClassroomId}`,
    method: 'post'
  })
}

// 直接加入教研室
export function directJoin(eduCloudJyClassroomId) {
  return request({
    url: `/basic/eduCloudJyClassroom/directJoin?eduCloudJyClassroomId=${eduCloudJyClassroomId}`,
    method: 'post'
  })
}

// 获取教研室详情
export function setButtonIsShow(eduCloudJyClassroomId) {
  return request({
    url: `/basic/eduCloudJyClassroom/setButtonIsShow?eduCloudJyClassroomId=${eduCloudJyClassroomId}`,
    method: 'get',
  })
}

// 教研室设置按钮是否显示
export function selectOne(id) {
  return request({
    url: `/basic/eduCloudJyClassroom/hero/selectOne?id=${id}`,
    method: 'get',
  })
}

// 创建教研备课按钮是否显示(登录之后判断)
export function prePareLessonsButtonIsShow(eduCloudJyClassroomId) {
  return request({
    url: `/basic/eduCloudJyClassroom/prePareLessonsButtonIsShow?eduCloudJyClassroomId=${eduCloudJyClassroomId}`,
    method: 'get',
  })
}

// 获取教研室下的所有用户
export function selectListByClassRoomId(eduCloudJyClassroomId, keyName) {
  return request({
    url: `/basic/eduCloudJyClassroom/hero/selectListByClassRoomId?eduCloudJyClassroomId=${eduCloudJyClassroomId}&keyName=${keyName}`,
    method: 'get',
  })
}

// 教研室点击增加浏览量(进入详情调用一次)
export function addLookNum(eduCloudJyClassroomId) {
  return request({
    url: `/basic/eduCloudJyClassroom/addLookNum?eduCloudJyClassroomId=${eduCloudJyClassroomId}`,
    method: 'post'
  })
}

// 教研室下的所有教研研讨
export function getClassRoomId(data) {
  return request({
    url: `/basic/eduCloudJyDiscuss/hero/selectListByClassRoomId`,
    method: 'post',
    data: data
  })
}

// 获取教研室下的所有备课列表
export function ClassRoomId(data) {
  return request({
    url: `/basic/eduCloudJyPrepareLessons/hero/selectListByClassRoomId`,
    method: 'post',
    data: data
  })
}


// ------------------前台接口-共享资料------------------

// 获取共享资料列表
export function selectListByConditionData(data) {
  return request({
    url: `/basic/eduCloudJyClassroomShareData/selectListByCondition`,
    method: 'post',
    data: data
  })
}


// ------------------前台接口-教学研讨------------------

// 教学研讨列表查询(前端未登录)
export function selectDiscussListNoLogin(data) {
  return request({
    url: `/basic/eduCloudJyDiscuss/hero/selectDiscussListNoLogin`,
    method: 'post',
    data: data
  })
}

// 教学研讨列表查询(登录之后)
export function selectDiscussListLogin(data) {
  return request({
    url: `/basic/eduCloudJyDiscuss/selectDiscussListLogin`,
    method: 'post',
    data: data
  })
}

// 教研研讨详情
export function selectOneDiscuss(id) {
  return request({
    url: `/basic/eduCloudJyDiscuss/selectOne?id=${id}`,
    method: 'get',
  })
}

// 教研研讨音频资源列表
export function selectAudioList(id) {
  return request({
    url: `/basic/eduCloudJyDiscuss/selectAudioList?id=${id}`,
    method: 'get',
  })
}

// 获取该教研的评论列表(结束获取全部)
export function getAllComment(discussId) {
  return request({
    url: `/basic/eduCloudJyDiscuss/getAllComment?discussId=${discussId}`,
    method: 'post'
  })
}

// 获取该教研的评论列表(进行中)
export function getComment(discussId, second) {
  return request({
    url: `/basic/eduCloudJyDiscuss/getComment?discussId=${discussId}&second=${second}`,
    method: 'post'
  })
}

// 获取该教研的评论列表
export function selectTalkAboutList(data) {
  return request({
    url: `/basic/eduCloudJyDiscuss/selectTalkAboutList`,
    method: 'post',
    data: data
  })
}

// 根据resourceType 类型获取资源(1 资源 2 评论资源 3 研讨总结资源)
export function selectListByDiscussIdAndType(discussId, resourceType) {
  return request({
    url: `/basic/eduCloudJyDiscuss/selectListByDiscussIdAndType?discussId=${discussId}&resourceType=${resourceType}`,
    method: 'post'
  })
}

// 点击添加教研研讨浏览量
export function addLookNumDiscuss(discussId) {
  return request({
    url: `/basic/eduCloudJyDiscuss/addLookNum?discussId=${discussId}`,
    method: 'post'
  })
}


// ------------------前台接口-协同备课------------------

// 前端获取备课列表(未登录)
export function ListByConditionNoLogin(data) {
  return request({
    url: `/basic/eduCloudJyPrepareLessons/hero/selectListByConditionNoLogin`,
    method: 'post',
    data: data
  })
}

// 前端获取备课列表(登录后)
export function ListByConditionLogin(data) {
  return request({
    url: `/basic/eduCloudJyPrepareLessons/selectListByConditionLogin`,
    method: 'post',
    data: data
  })
}


// ------------------前台接口-评比活动------------------

// 获取已登录活动大厅列表(教育云平台)
export function getLoggedEventhallList(data) {
  return request({
    url: `/basic/activeDetail/getLoggedEventhallList`,
    method: 'post',
    data: data
  })
}

// 获取未登录活动大厅列表(教育云平台)
export function getNotLoggedEventhallList(data) {
  return request({
    url: `/basic/activeDetail/hero/getNotLoggedEventhallList`,
    method: 'post',
    data: data
  })
}

// 获取活动阶段列表(教育云平台)
export function getActiveStageList(activeId) {
  return request({
    url: `/basic/activeDetail/getActiveStageList?activeId=${activeId}`,
    method: 'post'
  })
}

// 获取筹备阶段活动详情信息(教育云平台)
export function getActionDetail(activeId) {
  return request({
    url: `/basic/activeDetail/getActionDetail?activeId=${activeId}`,
    method: 'get'
  })
}

// 获取我的上传作品(教育云平台)
export function getMyActiveOpusList(activeId) {
  return request({
    url: `/basic/activeDetail/getMyActiveOpusList?activeId=${activeId}`,
    method: 'post'
  })
}

// 获取活动作品详情信息(教育云平台)
export function getActiveDetailInfo(detailId) {
  return request({
    url: `/basic/activeDetail/getActiveDetailInfo?detailId=${detailId}`,
    method: 'get'
  })
}

// 获取该活动下赛制分组信息(教育云平台)
export function getTournamentList(activeId) {
  return request({
    url: `/basic/activeDetail/getTournamentList?activeId=${activeId}`,
    method: 'get'
  })
}

// 获取此评委下赛制组信息(教育云平台)
export function getTournamentDataByUserId(activeId) {
  return request({
    url: `/basic/activeDetail/getTournamentDataByUserId?activeId=${activeId}`,
    method: 'get'
  })
}

// 删除我的作品(教育云平台)
export function deleteMyActiveOpus(detailId) {
  return request({
    url: `/basic/activeDetail/deleteMyActiveOpus?detailId=${detailId}`,
    method: 'post'
  })
}

// 新增-修改参赛作品信息(教育云平台)
export function operateActiveDetail(data) {
  return request({
    url: '/basic/activeDetail/operateActiveDetail',
    method: 'post',
    data: data
  })
}

// 获取该活动参比总人数(教育云平台)
export function getActiveParticipateCount(activeId) {
  return request({
    url: `/basic/activeDetail/getActiveParticipateCount?activeId=${activeId}`,
    method: 'get'
  })
}

// 判断当前登录人是否已经参加此活动 0：未参加；大于0：已参加(教育云平台)
export function isNotParticipateActive(activeId) {
  return request({
    url: `/basic/activeDetail/isNotParticipateActive?activeId=${activeId}`,
    method: 'get'
  })
}

// 修改评比活动浏览量(教育云平台)
export function updateActiveBrowseNum(activeId) {
  return request({
    url: `/basic/activeDetail/updateActiveBrowseNum?activeId=${activeId}`,
    method: 'post'
  })
}

// 判断当前登录人是否为活动创建者 0:不是；1:是(教育云平台)
export function isNotActiveCreator(activeId) {
  return request({
    url: `/basic/activeDetail/isNotActiveCreator?activeId=${activeId}`,
    method: 'get'
  })
}

// 判断当前用户是否为此活动评委(教育云平台)
export function isNotJudges(activeId, tournamentId) {
  return request({
    url: `/basic/activeDetail/isNotJudges?activeId=${activeId}&tournamentId=${tournamentId}`,
    method: 'get'
  })
}

// 判断当前登录人是否有资格参赛 0:不是；1:是(教育云平台)
export function isNotActiveContestant(activeId) {
  return request({
    url: `/basic/activeDetail/isNotActiveContestant?activeId=${activeId}`,
    method: 'get'
  })
}

// 判断当前登录人是否为作品上传者 0不是作品上传者；1是作品上传者(教育云平台)
export function isNotWorkUploader(detailId) {
  return request({
    url: `/basic/activeDetail/isNotWorkUploader?detailId=${detailId}`,
    method: 'get'
  })
}

// 根据活动id获取活动阶段(教育云平台)
export function getStageByActiveId(activeId) {
  return request({
    url: `/basic/activeDetail/getStageByActiveId?activeId=${activeId}`,
    method: 'get'
  })
}

// 根据条件获取分组-未分组评审作品详情(教育云平台)
export function getReviewDetailList(data) {
  return request({
    url: '/basic/activeDetail/getReviewDetailList',
    method: 'post',
    data: data
  })
}

// 获取投票列表(教育云平台)
export function getVoteDetailList(data) {
  return request({
    url: '/basic/activeDetail/getVoteDetailList',
    method: 'post',
    data: data
  })
}

// 获取当前登录人总剩余投票数(教育云平台)
export function getTotalRemainVoteNum(activeId) {
  return request({
    url: `/basic/activeDetail/getTotalRemainVoteNum?activeId=${activeId}`,
    method: 'get'
  })
}

// 作品投票(教育云平台)
export function voteActiveOpus(activeId, detailId) {
  return request({
    url: `/basic/activeDetail/voteActiveOpus?activeId=${activeId}&detailId=${detailId}`,
    method: 'post'
  })
}

// 获取作品详情(教育云平台)
export function getOpusDetail(detailId) {
  return request({
    url: `/basic/activeOpus/getOpusDetail?detailId=${detailId}`,
    method: 'get'
  })
}

// 获取评分项(教育云平台)
export function getActiveScoreItem(detailId) {
  return request({
    url: `/basic/activeOpus/getActiveScoreItem?detailId=${detailId}`,
    method: 'get'
  })
}

// 作品评分(教育云平台)
export function operateKpiScore(data) {
  return request({
    url: '/basic/activeOpus/operateKpiScore',
    method: 'post',
    data: data
  })
}

// 获取活动结果数量(教育云平台)
export function getActiveEffectCount(activeId) {
  return request({
    url: `/basic/activeDetail/getActiveEffectCount?activeId=${activeId}`,
    method: 'get'
  })
}

// 获取活动结果列表-所有人(教育云平台)
export function getActiveEffectList(activeId) {
  return request({
    url: `/basic/activeDetail/getActiveEffectList?activeId=${activeId}`,
    method: 'get'
  })
}

// 根据评比方式获取活动下所有作品(教育云平台)
export function getOpusDetailByCondition(data) {
  return request({
    url: '/basic/activeDetail/getOpusDetailByCondition',
    method: 'post',
    data: data
  })
}

// 设置活动奖项(教育云平台)
export function saveActiveEffect(data) {
  return request({
    url: '/basic/activeDetail/saveActiveEffect',
    method: 'post',
    data: data
  })
}

// 修改作品顺序(教育云平台)
export function updateAwardsSort(data) {
  return request({
    url: '/basic/activeDetail/updateAwardsSort',
    method: 'post',
    data: data
  })
}

// 获取各评委评分详情(教育云平台)
export function getJudgeTotalPoints(detailId) {
  return request({
    url: `/basic/activeOpus/getJudgeTotalPoints?detailId=${detailId}`,
    method: 'get'
  })
}

// 获取活动结果列表-自己(教育云平台)
export function getMyOpusEffect(activeId) {
  return request({
    url: `/basic/activeDetail/getMyOpusEffect?activeId=${activeId}`,
    method: 'get'
  })
}

// 判断当前登录人是否有权限下载作品 0：不允许下载；1：允许下载(教育云平台)
export function isNotCanDownloadOpus(activeId) {
  return request({
    url: `/basic/activeDetail/isNotCanDownloadOpus?activeId=${activeId}`,
    method: 'get'
  })
}


/** 名校课程 **/
// ------------------前台接口-名校风采------------------
// 获取名校主页数据
export function getSchoolHomePage() {
  return request({
    url: `/basic/eduCloudLiveCourse/hero/getSchoolHomePage`,
    method: 'get'
  })
}

// 获取全国名校列表
export function getSchoolHomePageList(data) {
  return request({
    url: '/basic/eduCloudLiveCourse/hero/getSchoolHomePageList',
    method: 'post',
    data: data
  })
}

// 获取学校主页数据
export function selectBySchoolId(schoolId) {
  return request({
    url: `/basic/eduCloudLiveCourse/hero/selectBySchoolId?schoolId=${schoolId}`,
    method: 'get'
  })
}

// ------------------前台接口-直播课程------------------
// 直播课程列表未登录
export function selectLiveCourseNoLogin(data) {
  return request({
    url: '/basic/eduCloudLiveCourse/hero/selectLiveCourseNoLogin',
    method: 'post',
    data: data
  })
}

// 直播课程列表登录状态
export function selectLiveCourseLogin(data) {
  return request({
    url: '/basic/eduCloudLiveCourse/selectLiveCourseLogin',
    method: 'post',
    data: data
  })
}

// 获取我的直播课程列表(教育云平台)
export function getMyLiveCourseList(data) {
  return request({
    url: '/basic/eduCloudJyCollect/getMyLiveCourseList',
    method: 'post',
    data: data
  })
}

// 直播间密码是否正确
export function checkPassword(liveId, password) {
  return request({
    url: `/basic/eduCloudLiveCourse/checkPassword?liveId=${liveId}&password=${password}`,
    method: 'post',
  })
}

// 直播课程详情
export function selectOneLive(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/selectOne?liveId=${liveId}`,
    method: 'get'
  })
}

// 直播课程详情
export function heroSelectOneLive(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/hero/selectOne?liveId=${liveId}`,
    method: 'get'
  })
}

// 直播流地址获取 POST
export function getLiveStream(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/hero/getLiveStream?liveId=${liveId}`,
    method: 'post',
  })
}

// 根据教室ID获取直播流(教育平台)
export function getEduLiveStream(roomId) {
  return request({
    url: `/edu/equipment/getLiveStream?roomId=${roomId}`,
    method: 'get'
  })
}

// 用户加入直播间
export function joinLive(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/joinLive?liveId=${liveId}`,
    method: 'post',
  })
}

// 用户退出直播间
export function quitLive(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/quitLive?liveId=${liveId}`,
    method: 'post',
  })
}

// 用户是否已经点赞
export function userIsLike(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/userIsLike?liveId=${liveId}`,
    method: 'get'
  })
}

// 直播点赞
export function addLikeNum(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/addLikeNum?liveId=${liveId}`,
    method: 'post',
  })
}

// 直播取消点赞
export function reduceLikeNum(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/reduceLikeNum?liveId=${liveId}`,
    method: 'post',
  })
}

// 是否有禁言功能
export function isBanset(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/isBanset?liveId=${liveId}`,
    method: 'get',
  })
}

// 修改公告
export function updateSimple(data) {
  return request({
    url: '/basic/eduCloudLiveCourse/updateSimple',
    method: 'post',
    data: data
  })
}

// 设置全体禁言
export function setSilence(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/setSilence?liveId=${liveId}`,
    method: 'post',
  })
}

// 取消全体禁言
export function cancelSilence(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/cancelSilence?liveId=${liveId}`,
    method: 'post',
  })
}

// 直播间用户列表
export function selectUserListByLiveId(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/selectUserListByLiveId?liveId=${liveId}`,
    method: 'get',
  })
}

// 禁言用户
export function banUser(id) {
  return request({
    url: `/basic/eduCloudLiveCourse/banUser?id=${id}`,
    method: 'post',
  })
}

// 解除用户禁言
export function removeBanUser(id) {
  return request({
    url: `/basic/eduCloudLiveCourse/removeBanUser?id=${id}`,
    method: 'post',
  })
}

// 用户是否被禁言
export function isForbidden(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/isForbidden?liveId=${liveId}`,
    method: 'get',
  })
}

// 用户发布评论
export function postComment(data) {
  return request({
    url: `/basic/eduCloudLiveCourse/postComment`,
    method: 'post',
    data: data,
  })
}

// 心跳上报人数
export function setLivePackValue(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/setLivePackValue?liveId=${liveId}`,
    method: 'post',
  })
}


// ------------------前台接口-微课-课例------------------
// 根据学段id获取年级列表(教育云平台-年级)
export function listByStudyPhaseId(studyPhaseId) {
  return request({
    url: `/basic/edu/cloud/grade/hero/get/listByStudyPhaseId?studyPhaseId=${studyPhaseId}`,
    method: 'post',
  })
}

// 根据学段id获取学科列表
export function listByStudyPhaseSubject(studyPhaseId) {
  return request({
    url: `/basic/edu/cloud/subject/hero/get/listByStudyPhaseId?studyPhaseId=${studyPhaseId}`,
    method: 'get'
  })
}

// 学习课程查询(课程主页进入)
export function selectListByCondition(data) {
  return request({
    url: '/basic/eduCloudStudyCourse/hero/selectListByCondition',
    method: 'post',
    data: data
  })
}

// 学习课程查询(学校主页进入)
export function selectListBySchoolCondition(data) {
  return request({
    url: '/basic/eduCloudStudyCourse/hero/selectListBySchoolCondition',
    method: 'post',
    data: data
  })
}

// 查询单个学习课程
export function selectById(id) {
  return request({
    url: `/basic/eduCloudStudyCourse/selectById?id=${id}`,
    method: 'get'
  })
}

// 查询单个学习课程(免登录)
export function selectByIdHero(id) {
  return request({
    url: `/basic/eduCloudStudyCourse/hero/selectById?id=${id}`,
    method: 'get'
  })
}

// 新增用户观看历史
export function addHistory(data) {
  return request({
    url: '/basic/eduCloudStudyCourse/addHistory',
    method: 'post',
    data: data
  })
}

// 获取当前用户观看历史
export function getHistoryList() {
  return request({
    url: `/basic/eduCloudStudyCourse/getHistoryList`,
    method: 'get'
  })
}

// 判断用户是否点赞
export function userIsLikeVideo(id) {
  return request({
    url: `/basic/eduCloudStudyCourse/userIsLike?id=${id}`,
    method: 'get'
  })
}

// 用户点赞
export function isLike(id) {
  return request({
    url: `/basic/eduCloudStudyCourse/isLike?id=${id}`,
    method: 'get'
  })
}

// 用户取消点赞
export function cancelLike(id) {
  return request({
    url: `/basic/eduCloudStudyCourse/cancelLike?id=${id}`,
    method: 'get'
  })
}

// 用户进入学习课程
export function joinStudyCourse(id) {
  return request({
    url: `/basic/eduCloudStudyCourse/joinStudyCourse?id=${id}`,
    method: 'post',
  })
}


/** 资源中心 **/
// ------------------前台接口-省平台资源------------------
// 校级上传资源数量排行
export function schoolRank() {
  return request({
    url: '/basic/edu/cloud/resource/review/hero/schoolRank',
    method: 'post',
  })
}

// 下载数量排行
export function downloadRank() {
  return request({
    url: '/basic/edu/cloud/resource/review/hero/downloadRank',
    method: 'post',
  })
}

// 用户上传资源数量排行
export function userRank() {
  return request({
    url: '/basic/edu/cloud/resource/review/hero/userRank',
    method: 'post',
  })
}

// 获取个人信息-全角色(教育云平台-个人信息)
export function info(data) {
  return request({
    url: '/user/edu/cloud/get/personal/info',
    method: 'post',
    data: data
  })
}

// 获取安徽省平台学科列表(教育云平台)
export function subjectList() {
  return request({
    url: `/user/get/ahy/subjectList`,
    method: 'post'
  })
}

// 获取安徽省平台年级列表(教育云平台)
export function gradeList() {
  return request({
    url: `/user/get/ahy/gradeList`,
    method: 'post'
  })
}

// 获取安徽省平台拥有教材的出版社版本列表(教育云平台)
export function editionList() {
  return request({
    url: `/user/get/ahy/editionList`,
    method: 'post'
  })
}

// 获取安徽省平台教材列表(教育云平台)
export function bookList(data) {
  return request({
    url: `/user/get/ahy/bookList`,
    method: 'post',
    data: data
  })
}

// 获取安徽省平台资源列表(教育云平台)
export function resourceList(data) {
  return request({
    url: '/user/get/ahy/resourceList',
    method: 'post',
    data: data
  })
}

// 获取安徽省平台资源的预览地址(教育云平台)
export function getPreviewUrl(data) {
  return request({
    url: '/user/get/ahy/getPreviewUrl',
    method: 'post',
    data: data
  })
}

// 获取安徽省平台资源的下载地址(教育云平台)
export function getResourceUrl(data) {
  return request({
    url: '/user/get/ahy/getResourceUrl',
    method: 'post',
    data: data
  })
}

// 状元网获取学段
export function studyphaseList() {
  return request({
    url: `/user/edu/cloud/zyw/hero/studyphase/list`,
    method: 'get'
  })
}

// 状元网获取学科
export function zywSubjectList(studyPhaseId) {
  return request({
    url: `/user/edu/cloud/zyw/hero/subject/list?studyPhaseId=${studyPhaseId}`,
    method: 'get'
  })
}

// 状元网获取年级
export function zywGradeList(studyPhaseId) {
  return request({
    url: `/user/edu/cloud/zyw/hero/grade/list?studyPhaseId=${studyPhaseId}`,
    method: 'get'
  })
}

// 状元网获取资源文件类型
export function resourceFileTypeList() {
  return request({
    url: `/user/edu/cloud/zyw/resourceFileType/list`,
    method: 'get'
  })
}

// 查询资源类型列表(教育云平台)
export function getResourceType(folderFlag) {
  return request({
    url: `/basic/edu/cloud/resource/review/sel/resourceType?folderFlag=${folderFlag}`,
    method: 'get'
  })
}

// 状元网获取资源年份
export function resourceYearList() {
  return request({
    url: `/user/edu/cloud/zyw/hero/resourceYear/list`,
    method: 'get'
  })
}

// 状元网获取教材版本及章节
export function materialList(data) {
  return request({
    url: '/user/edu/cloud/zyw/hero/textbook/material/list',
    method: 'post',
    data: data
  })
}

// 状元网获取知识点列表
export function knowledgePointsList(data) {
  return request({
    url: '/user/edu/cloud/zyw/hero/knowledge/points/list',
    method: 'post',
    data: data
  })
}

// 状元网获取资源列表
export function zywGetResourceList(data) {
  return request({
    url: '/user/edu/cloud/zyw/hero/get/resource/list',
    method: 'post',
    data: data
  })
}

// 获取状元网资源下载地址
// export function zywGetResourceDownUrl(data) {
//   return request({
//     url: '/user/edu/cloud/zyw/get/resource/downUrl',
//     method: 'post',
//     data: data
//   })
// }
export function zywGetResourceDownUrl(data) {
  return request({
    url: `/user/edu/cloud/zyw/hero/get/resource/download/url?resourcesId=${data.resourcesId}`,
    method: 'get'
  })
}

// 收藏资源(教育云平台)
export function resourceAddCollect(data) {
  return request({
    url: '/basic/edu/cloud/resource/review/add/collect',
    method: 'post',
    data: data
  })
}

// 状元网获取资源详情
export function zywResourceInfo(resourceId) {
  return request({
    url: `/user/edu/cloud/zyw/hero/get/resource/info?resourceId=${resourceId}`,
    method: 'get'
  })
}

// url转化二维码(教育云平台)
export function getResourceQcCode(data) {
  return request({
    url: `/basic/edu/cloud/resource/review/hero/get/qcCode`,
    method: 'post',
    data: data
  })
}

// 21世纪教育获取学科
export function cnjySubjectList(studyPhaseId, cnjyType) {
  return request({
    url: `/user/edu/cloud/cnjy/hero/subject/list?studyPhaseId=${studyPhaseId}&cnjyType=${cnjyType}`,
    method: 'get'
  })
}

// 21世纪教育获取资源列表
export function cnjyResourceList(data) {
  return request({
    url: `/user/edu/cloud/cnjy/hero/get/resource/list`,
    method: 'post',
    data: data
  })
}

// 21世纪教育获取教材版本信息
export function cnjyTextbookEditionList(studyPhaseId, subjectid, cnjyType) {
  return request({
    url: `/user/edu/cloud/cnjy/hero/textbook/edition/list?studyPhaseId=${studyPhaseId}&subjectid=${subjectid}&cnjyType=${cnjyType}`,
    method: 'get'
  })
}

// 21世纪教育获取教材章节信息
export function cnjyTextbookChapterList(bookid, cnjyType) {
  return request({
    url: `/user/edu/cloud/cnjy/hero/textbook/chapter/list?bookid=${bookid}&cnjyType=${cnjyType}`,
    method: 'get'
  })
}

// 21世纪教育获取知识点列表
export function cnjyKnowledgePointsList(studyPhaseId, subjectid, cnjyType) {
  return request({
    url: `/user/edu/cloud/cnjy/hero/knowledge/points/list?studyPhaseId=${studyPhaseId}&subjectid=${subjectid}&cnjyType=${cnjyType}`,
    method: 'get'
  })
}

// 21世纪教育(收费慎用)获取资源详情
export function getCnjyResourceInfo(itemids) {
  return request({
    url: `/user/edu/cloud/cnjy/get/resource/info?itemids=${itemids}`,
    method: 'get'
  })
}

// 21世纪教育获取资源预览信息
export function getResourcePreviewInfo(itemid) {
  return request({
    url: `/user/edu/cloud/cnjy/hero/get/resource/preview/info?itemid=${itemid}`,
    method: 'get'
  })
}

// 知识点资源接口
// 获取学段列表
export function getPhaseList() {
  return request({
    url: `/user/v1/resource/video/hero/get/phase/list`,
    method: 'get'
  })
}

// 根据学段获取学科列表
export function getSubjectList(phaseId) {
  return request({
    url: `/user/v1/resource/video/hero/get/subject/list?phaseId=${phaseId}`,
    method: 'get'
  })
}

// 根据学段获取年级列表
export function getGradeList(phaseId) {
  return request({
    url: `/user/v1/resource/video/hero/get/grade/list?phaseId=${phaseId}`,
    method: 'get'
  })
}

// 根据年级学科获取版本列表
export function getVersionList(gradeName, subjectId) {
  return request({
    url: `/user/v1/resource/video/hero/get/version/list?gradeName=${gradeName}&subjectId=${subjectId}`,
    method: 'get'
  })
}

// 根据年级学科版本获取分类列表
export function getHeroTypeList(gradeName, subjectId, versionName) {
  return request({
    url: `/user/v1/resource/video/hero/get/type/list?gradeName=${gradeName}&subjectId=${subjectId}&versionName=${versionName}`,
    method: 'get'
  })
}

// 根据分类查询视频列表
export function getHeroVideoList(pageNum, pageSize, typeId) {
  return request({
    url: `/user/v1/resource/video/hero/get/video/list?pageNum=${pageNum}&pageSize=${pageSize}&typeId=${typeId}`,
    method: 'get'
  })
}

// 获取视频源地址域
export function getVideoDomain() {
  return request({
    url: `/user/v1/resource/video/hero/get/video/domain`,
    method: 'get'
  })
}

// 获取视频详情
export function getVideoDetail(typeId, videoId) {
  return request({
    url: `/user/v1/resource/video/hero/get/video/detail?typeId=${typeId}&videoId=${videoId}`,
    method: 'get'
  })
}


/** 新闻公告 **/
// ------------------前台接口-新闻公告------------------
// 获取前台列表
export function selectWebListHero(data) {
  return request({
    url: `/basic/eduCloudAnnouncement/hero/selectWebList`,
    method: 'post',
    data: data
  })
}

// 获取前台列表
export function selectWebList(data) {
  return request({
    url: `/basic/eduCloudAnnouncement/selectWebList`,
    method: 'post',
    data: data
  })
}

// 获取前台列表
export function HeroselectWebList(data) {
  return request({
    url: `/basic/eduCloudAnnouncement/hero/selectWebList`,
    method: 'post',
    data: data
  })
}

// ------------------前台接口-收藏------------------
// 教研收藏(教育云平台)
export function seminarCollect(data) {
  return request({
    url: '/basic/eduCloudJyCollect/seminarCollect',
    method: 'post',
    data: data
  })
}

// 取消教研收藏(教育云平台)
export function cancelSeminarCollect(id) {
  return request({
    url: `/basic/eduCloudJyCollect/cancelSeminarCollect?id=${id}`,
    method: 'post'
  })
}

// 获取教学研讨-协同备课列表(教育云平台)
export function getResearchSeminarList(data) {
  return request({
    url: '/basic/eduCloudJyCollect/getResearchSeminarList',
    method: 'post',
    data: data
  })
}

// 获取共享资料列表(教育云平台)
export function getShareMaterialList(data) {
  return request({
    url: '/basic/eduCloudJyCollect/getShareMaterialList',
    method: 'post',
    data: data
  })
}

// 获取我的课程列表(教育云平台)
export function getMyStudyCourseList(data) {
  return request({
    url: '/basic/eduCloudJyCollect/getMyStudyCourseList',
    method: 'post',
    data: data
  })
}

// 我的收藏资源列表查询(教育云平台)
export function resourceGetMyCollect(data) {
  return request({
    url: '/basic/edu/cloud/resource/review/get/myCollect',
    method: 'post',
    data: data
  })
}


// ------------------后台接口-前台管理------------------
// 前台-首页管理信息(教育云平台-试卷管理)
export function receptionistInfo() {
  return request({
    url: `/basic/receptionist/get/info`,
    method: 'get'
  })
}

// 首页管理信息(未登录)(教育云平台-试卷管理)
export function receptionistHeroInfo() {
  return request({
    url: `/basic/receptionist/hero/get/index/info`,
    method: 'get'
  })
}

// 保存(教育云平台-前台管理)
export function receptionistSave(data) {
  return request({
    url: '/basic/receptionist/save',
    method: 'post',
    data: data
  })
}

// 重置(教育云平台-前台管理)
export function receptionistReset() {
  return request({
    url: `/basic/receptionist/reset`,
    method: 'get'
  })
}

// ------------------后台接口-私有化-前台管理------------------
// 获取第三方应用列表
export function appGetList() {
  return request({
    url: `/auth/v1/open/app/get/list`,
    method: 'get'
  })
}

// 角色空间列表
export function spaceList(userId='') {
  return request({
    url: `/auth/v1/open/app/get/role/space/list?userId=${userId}`,
    method: 'get'
  })
}

// 获取第三方应用地址
export function authorize(clientId, url, loginId) {
  return request({
    url: `/auth/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${url}&loginId=${loginId}`,
    method: 'get'
  })
}

// 获取当前学校前端管理
export function eduCloudReceptionistSchoolSelectBySchoolId(schoolId) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/selectByParentId?parentId=${schoolId}`,
    method: 'post',
  })
}

// 保存当前学校设置
export function eduCloudReceptionistSchoolSaveData(data) {
  return request({
    url: '/basic/eduCloudReceptionistSchool/saveData',
    method: 'post',
    data: data
  })
}

// 重置
export function eduCloudReceptionistSchoolResetData(schoolId) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/resetData?parentId=${schoolId}`,
    method: 'post'
  })
}

// 重置首页内容
export function eduCloudReceptionistSchoolResetHomeData(parentId) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/resetHomeData?parentId=${parentId}`,
    method: 'post'
  })
}

// 初始化学校前端管理
export function eduCloudReceptionistSchoolInitialSchoolId(schoolId) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/initialParentId?parentId=${schoolId}`,
    method: 'post'
  })
}

// 获取首页列表
export function eduCloudReceptionistSchoolGetHomeDataList(level) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/hero/getHomeDataList?level=${level}`,
    method: 'post'
  })
}

// 区管下获取当前区域下学校列表
export function getSchoolByParentId(parentId) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/getSchoolByParentId?parentId=${parentId}`,
    method: 'post'
  })
}

// 获取学校列表
export function getSchoolList(data) {
  return request({
    url: '/basic/eduCloudReceptionistSchool/getSchoolList',
    method: 'post',
    data: data
  })
}

// 判断是否可进入首页
export function eduCloudReceptionistSchoolIsJoin(level, parentId) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/isJoin?level=${level}&parentId=${parentId}`,
    method: 'get'
  })
}

// 删除页脚
export function eduCloudReceptionistSchoolDeleteFoot(id) {
  return request({
    url: `/basic/receptionist/deleteFoot?id=${id}`,
    method: 'post'
  })
}

// 页脚升序
export function eduCloudReceptionistSchoolAddFootSort(id) {
  return request({
    url: `/basic/receptionist/addFootSort?id=${id}`,
    method: 'post'
  })
}

// 首页模块升序
export function eduCloudReceptionistSchoolAddHomeDataSort(id) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/addHomeDataSort?id=${id}`,
    method: 'post'
  })
}

// 首页模块是否展示
export function eduCloudReceptionistSchoolHomeDataDisplay(display, id) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/homeDataDisplay?display=${display}&id=${id}`,
    method: 'post'
  })
}

// 首页模块降序
export function eduCloudReceptionistSchoolReduceHomeDataSort(id) {
  return request({
    url: `/basic/eduCloudReceptionistSchool/reduceHomeDataSort?id=${id}`,
    method: 'post'
  })
}

// 页脚降序
export function eduCloudReceptionistSchoolReduceFootSort(id) {
  return request({
    url: `/basic/receptionist/reduceFootSort?id=${id}`,
    method: 'post'
  })
}

// 添加版权信息
export function addCopyright(data) {
  return request({
    url: '/basic/receptionist/addCopyright',
    method: 'post',
    data: data
  })
}

// 修改版权信息
export function updateCopyright(data) {
  return request({
    url: '/basic/receptionist/updateCopyright',
    method: 'post',
    data: data
  })
}

// 删除版权信息
export function deleteCopyright(id) {
  return request({
    url: `/basic/receptionist/deleteCopyright?id=${id}`,
    method: 'post'
  })
}

// 版权信息升序
export function addCopyrightSort(id) {
  return request({
    url: `/basic/receptionist/addCopyrightSort?id=${id}`,
    method: 'post'
  })
}

// 版权信息降序
export function reduceCopyrightSort(id) {
  return request({
    url: `/basic/receptionist/reduceCopyrightSort?id=${id}`,
    method: 'post'
  })
}

// 删除顶部导航
export function eduCloudReceptionistSchoolDeletop(id) {
  return request({
    url: `/basic/receptionist/deleteMoudle?id=${id}`,
    method: 'post'
  })
}

// 修改首页模块
export function eduCloudReceptionistSchoolUpdateHomeData(data) {
  return request({
    url: '/basic/eduCloudReceptionistSchool/updateHomeData',
    method: 'post',
    data: data
  })
}

// 顶部导航栏升序
export function eduCloudReceptionistSchoolAddTopSort(id) {
  return request({
    url: `/basic/receptionist/addMoudleSort?id=${id}`,
    method: 'post'
  })
}

// 修改页脚
export function eduCloudReceptionistSchoolUpdateFoot(data) {
  return request({
    url: '/basic/receptionist/updateFoot',
    method: 'post',
    data: data
  })
}

// 添加页脚
export function eduCloudReceptionistSchoolAddFoot(data) {
  return request({
    url: '/basic/receptionist/addFoot',
    method: 'post',
    data: data
  })
}

// 删除轮播图
export function eduCloudReceptionistSchoolDeleteSlideshow(id) {
  return request({
    url: `/basic/receptionist/deleteSlideshow?id=${id}`,
    method: 'post'
  })
}

// 顶部导航栏降序
export function eduCloudReceptionistSchoolReduceTopSort(id) {
  return request({
    url: `/basic/receptionist/reduceMoudleSort?id=${id}`,
    method: 'post'
  })
}

// 轮播图升序
export function eduCloudReceptionistSchoolAddSlideshowSort(id) {
  return request({
    url: `/basic/receptionist/addSlideshowSort?id=${id}`,
    method: 'post'
  })
}

// 顶部导航是否显示
export function eduCloudReceptionistSchoolTopDisplay(id) {
  return request({
    url: `/basic/receptionist/moudleDisplay?id=${id}`,
    method: 'post'
  })
}

// 轮播图降序
export function eduCloudReceptionistSchoolReduceSlideshowSort(id) {
  return request({
    url: `/basic/receptionist/reduceSlideshowSort?id=${id}`,
    method: 'post'
  })
}

// 添加顶部导航
export function eduCloudReceptionistSchoolAddTop(data) {
  return request({
    url: '/basic/receptionist/addMoudle',
    method: 'post',
    data: data
  })
}

// 修改顶部导航
export function eduCloudReceptionistSchoolUpdateTop(data) {
  return request({
    url: '/basic/receptionist/updateMoudle',
    method: 'post',
    data: data
  })
}

// 轮播图是否展示
export function eduCloudReceptionistSchoolSlideshowDisplay(id) {
  return request({
    url: `/basic/receptionist/display?id=${id}`,
    method: 'post'
  })
}

// 页脚友链是否展示
export function footDisplay(id) {
  return request({
    url: `/basic/receptionist/footDisplay?id=${id}`,
    method: 'post'
  })
}

// 修改轮播图
export function eduCloudReceptionistSchoolUpdateSlideshow(data) {
  return request({
    url: '/basic/receptionist/updateSlideshow',
    method: 'post',
    data: data
  })
}

// 添加轮播图
export function eduCloudReceptionistSchoolAddSlideshow(data) {
  return request({
    url: '/basic/receptionist/addSlideshow',
    method: 'post',
    data: data
  })
}

// ------------------后台接口-高级管理------------------
// 保存-编辑超管网站置灰、强制视频相关信息(教育云平台-超管-管理)
export function operateSeniorManagement(data) {
  return request({
    url: '/basic/seniorManagement/operate/seniorManagement',
    method: 'post',
    data: data
  })
}

// 查询超管网站置灰、强制视频相关信息(教育云平台-超管-管理)
export function getSeniorManagement() {
  return request({
    url: `/basic/seniorManagement/hero/get/seniorManagement`,
    method: 'get'
  })
}

// ------------------后台接口-公告管理------------------
// 获取当前级别的公告类型列表
export function getBulletinTypeList() {
  return request({
    url: `/basic/eduCloudAnnouncement/getTypeList`,
    method: 'get'
  })
}

// 免登陆获取当前级别的公告类型列表
export function getBulletinHeroTypeList() {
  return request({
    url: `/basic/eduCloudAnnouncement/hero/getTypeList`,
    method: 'get'
  })
}

// 新增公告类型
export function addBulletinType(data) {
  return request({
    url: '/basic/eduCloudAnnouncement/addType',
    method: 'post',
    data: data
  })
}

// 修改公告类型
export function updateBulletinType(data) {
  return request({
    url: '/basic/eduCloudAnnouncement/updateType',
    method: 'post',
    data: data
  })
}

// 删除公告类型
export function deleteBulletinType(typeId) {
  return request({
    url: `/basic/eduCloudAnnouncement/deleteType?typeId=${typeId}`,
    method: 'post'
  })
}

// 新增公告
export function addBulletinInsertOne(data) {
  return request({
    url: '/basic/eduCloudAnnouncement/insertOne',
    method: 'post',
    data: data
  })
}

// 获取后台列表
export function selectListByUserId(data) {
  return request({
    url: '/basic/eduCloudAnnouncement/selectListByUserId',
    method: 'post',
    data: data
  })
}

// 公告详情
export function selectBulletinOne(id) {
  return request({
    url: `/basic/eduCloudAnnouncement/hero/selectOne?id=${id}`,
    method: 'get'
  })
}

// 修改公告
export function updateBulletinOne(data) {
  return request({
    url: '/basic/eduCloudAnnouncement/updateOne',
    method: 'post',
    data: data
  })
}

// 删除公告
export function deleteBulletinOne(ids) {
  return request({
    url: `/basic/eduCloudAnnouncement/deleteOne?ids=${ids}`,
    method: 'post'
  })
}

// ------------------后台接口-行为分析------------------
// 修改公告
export function courseResultTableList(data) {
  return request({
    url: '/analysis/v2/faceAnalysis/courseResultTableList',
    method: 'post',
    data: data
  })
}

// 获取年级班级列表
export function analysisClassList(schoolId) {
  return request({
    url: `/analysis/other/grade/classList?schoolId=${schoolId}`,
    method: 'post'
  })
}

// 获取对比列表
export function getComparisonList() {
  return request({
    url: `/analysis/v2/faceAnalysis/getComparisonList`,
    method: 'get'
  })
}

// 添加对比
export function addComparison(courseId) {
  return request({
    url: `/analysis/v2/faceAnalysis/addComparison?courseId=${courseId}`,
    method: 'post'
  })
}

// 移出对比
export function removeComparison(courseId) {
  return request({
    url: `/analysis/v2/faceAnalysis/removeComparison?courseId=${courseId}`,
    method: 'post'
  })
}

// 获取自动课表设置
export function eduCloudAnalyseButton(schoolId) {
  return request({
    url: `/analysis/eduCloudAnalyseButton/getOne?schoolId=${schoolId}`,
    method: 'get'
  })
}

// 修改自动课表设置
export function updateButton(data) {
  return request({
    url: '/analysis/eduCloudAnalyseButton/updateButton',
    method: 'post',
    data: data
  })
}

// 删除人脸（云平台）
export function deletePhoto(userId) {
  return request({
    url: `/analysis/v2.0/faceLibrary/deletePhoto?userId=${userId}`,
    method: 'post'
  })
}

// 新增ai监考
export function eduCloudAnalyseExamInsert(data) {
  return request({
    url: '/analysis/eduCloudAnalyseExam/insert',
    method: 'post',
    data: data
  })
}

// 修改ai监考
export function eduCloudAnalyseExamUpdate(data) {
  return request({
    url: '/analysis/eduCloudAnalyseExam/update',
    method: 'post',
    data: data
  })
}

// ai监考列表
export function eduCloudAnalyseExamGetList(data) {
  return request({
    url: '/analysis/eduCloudAnalyseExam/getList',
    method: 'post',
    data: data
  })
}

// 删除ai监考
export function eduCloudAnalyseExamDeleteById(id) {
  return request({
    url: `/analysis/eduCloudAnalyseExam/deleteById?id=${id}`,
    method: 'get'
  })
}

// 开始监考
export function startExam(id) {
  return request({
    url: `/analysis/eduCloudAnalyseExam/startExam?id=${id}`,
    method: 'post'
  })
}

// 班级学生列表
export function classStudentList(schoolId) {
  return request({
    url: `/analysis/other/classStudentList?schoolId=${schoolId}`,
    method: 'post'
  })
}

// ------------------后台接口-在线听评课------------------
// 增加浏览量
export function addViewNumber(courseId) {
  return request({
    url: `/basic/themeCourse/hero/addViewNumber?courseId=${courseId}`,
    method: 'post'
  })
}

// 根据直播id查询录制回放地址
export function selectRecodByLiveId(liveId) {
  return request({
    url: `/basic/eduCloudLiveCourse/hero/selectRecodByLiveId?liveId=${liveId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/front.js